<template>

    <div class="release-flow-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">Release flow</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-text-field
                                    v-model="form.attributes.title"
                                    :items="releaseFlows"
                                    v-bind:label="$t('releaseFlow.title')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    return-object
                            ></v-text-field>
                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>

            <v-card class="mt-4" v-if="showDepartments">
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>Freigabeablauf für <span v-text="form.attributes.title"></span></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn :to="{ name: 'release-step-detail', params: { flowid: id }}" icon>
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-list>
                    <v-list-tile
                            v-for="item, index in form.relationships['releaseSteps'].data"
                            :key="index"
                            avatar
                            @click=""
                    >
                        <v-list-tile-action>
                            <v-icon v-if="item.icon" color="pink">star</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title v-text="item.attributes.title"></v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn :to="{ name: 'release-step-detail', params: { flowid: id, id: item.id }}" icon>
                            <v-icon color="primary">edit</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {SlickList, SlickItem} from 'vue-slicksort';

    export default {
        components: {
            SlickItem,
            SlickList
        },
        mounted() {
            if(this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('releaseFlows/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['releaseFlows/byId']({id: this.id});
                    this.form.attributes.title = widget.attributes.title;

                    var parent = widget;
                    this.$store.dispatch('releaseSteps/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseSteps/related']({parent});
                        this.form.relationships['releaseSteps'].data = related;
                    });

                });
            } else {

            }

            this.$store.dispatch('releaseFlows/loadAll').then(() => {
                const widgets = this.$store.getters['releaseFlows/all'];
                widgets.forEach((item) => {
                    this.releaseFlows.push(item);
                });
                this.showDepartments = true;
            });
        },
        methods: {
            ...mapActions({
                delete: 'releaseFlow/delete',
            }),

            saveAction: function() {
                if(this.$route.params.id != null) {
                    var widget = this.$store.getters['releaseFlows/byId']({ id: this.id });
                    widget.attributes.title = this.form.attributes.title;
                    delete widget.relationships;
                    this.$store.dispatch('releaseFlows/update', widget).then(() => {
                         this.$router.back();
                    });
                } else {
                    var widget = this.form;
                    delete widget.relationships;
                    delete widget.id;
                    this.$store.dispatch('releaseFlows/create', widget).then(() => {
                        this.$router.back();
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "releaseFlows/isLoading",
                error: "releaseFlows/isError",
            }),
        },
        data: () => ({
            form: {
                id: null,
                attributes: {
                    title: '',
                },
                relationships: {
                    'releaseSteps': {data: {}},
                },

            },
            valid: false,
            id: null,
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            releaseFlows: [],
            showDepartments: false,
        })
    }
</script>
